<form [formGroup]="formGroup()">
  <div class="row flex-between-center">
    <div class="col-12 my-2">
      <app-validated-input
        [label]="'general.email'"
        inputFormControlName="emailAddress"
        [inputFormControl]="formGroup().controls.emailAddress"
      />
    </div>
  </div>
</form>
